import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loader: Promise<HTMLIonLoadingElement> | undefined;

  constructor(private loadingController: LoadingController, private translateService: TranslateService) {}

  public showLoader() {
    this.loader = this.loadingController.create();
    this.loader.then(loader => {
      loader.present();
    });
  }

  public showLoaderStatus() {
    this.loader = this.loadingController.create({
      message: this.translateService.instant('COMMON.PROCESSING')
    });
    this.loader.then(loader => {
      loader.present();
    });
  }

  public hideLoader() {
    if(this.loader){
      this.loader.then(loader => {
        loader.dismiss();
      });
    }
  }
}
